import { getTitleForMeeting } from '@web/utility';
import { ApplicationEnum, CHAT_DEFAULT_TITLE, ChatRoomTypeEnum } from '@workalizer/shared';
import { chatOneToOneRoomTypes } from '@workalizer/shared/utils';
export var getChatEventDisplayTitle = function (event) {
    var _a, _b, _c;
    var _d = (_a = event.chatEvent) !== null && _a !== void 0 ? _a : {}, room = _d.room, subUser = _d.subUser, dmPeerUser = _d.dmPeerUser;
    var roomTitle = room === null || room === void 0 ? void 0 : room.title;
    var isUserToUserDm = (room === null || room === void 0 ? void 0 : room.type) === ChatRoomTypeEnum.USER_TO_USER_DIRECT_MESSAGE;
    var counterpartUser = isUserToUserDm ? (subUser !== null && subUser !== void 0 ? subUser : dmPeerUser) : subUser;
    if (roomTitle && roomTitle !== CHAT_DEFAULT_TITLE) {
        return roomTitle;
    }
    if ((room === null || room === void 0 ? void 0 : room.type) &&
        chatOneToOneRoomTypes.includes(room.type) &&
        ((counterpartUser === null || counterpartUser === void 0 ? void 0 : counterpartUser.name) || (counterpartUser === null || counterpartUser === void 0 ? void 0 : counterpartUser.email))) {
        return (_c = (_b = counterpartUser.name) !== null && _b !== void 0 ? _b : counterpartUser.email) !== null && _c !== void 0 ? _c : '';
    }
    if (event.title && event.title !== CHAT_DEFAULT_TITLE) {
        return event.title;
    }
    return roomTitle !== null && roomTitle !== void 0 ? roomTitle : CHAT_DEFAULT_TITLE;
};
export var formatEventsLogEventTitle = function (event, t) {
    var _a, _b, _c, _d, _e, _f;
    var applicationName = event.applicationName;
    var actionKey = "eventsLog.eventActionTitle.".concat(event.action);
    switch (applicationName) {
        case ApplicationEnum.DRIVE: {
            var docTitle = (_b = (_a = event.documentEvent) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.title;
            return "\"".concat((_c = docTitle !== null && docTitle !== void 0 ? docTitle : event.title) !== null && _c !== void 0 ? _c : '', "\" ").concat(t(actionKey));
        }
        case ApplicationEnum.MEET: {
            var titleMeet = ((_d = event.meetingsEvent) === null || _d === void 0 ? void 0 : _d.meeting)
                ? ((_e = getTitleForMeeting(event.meetingsEvent.meeting)) !== null && _e !== void 0 ? _e : event.title)
                : event.title;
            return "\"".concat(titleMeet !== null && titleMeet !== void 0 ? titleMeet : '', "\" ").concat(t(actionKey));
        }
        case ApplicationEnum.GMAIL: {
            if (event.value != null && event.value > 0) {
                return t(actionKey, { count: event.value });
            }
            return t(actionKey);
        }
        case ApplicationEnum.CHAT: {
            return "\"".concat(getChatEventDisplayTitle(event), "\" ").concat(t(actionKey));
        }
        default:
            return "\"".concat((_f = event.title) !== null && _f !== void 0 ? _f : '', "\" ").concat(t(actionKey));
    }
};
